import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

const PrintButton = () => (
  <Button onClick={() => window.print()}>
    <Glyphicon glyph="print" /> print this page
  </Button>
);

export default PrintButton;



// WEBPACK FOOTER //
// ./src/components/util/PrintButton.js